<!--
 * @Description: 条件配置
 * @Author: wangwangwang
 * @Date: 2020-07-23 09:33:47
 * @LastEditors: Roger Wei
 * @LastEditTime: 2022-04-24 10:08:01
--> 
<template>
	<el-dialog v-dialogDrag :visible.sync="conditionVisible" width="70%" :before-close="handleClose" @open="onOpen">
		<span slot="title">设置条件</span>
		<div class="dialoginfo" style="border:0">
			<div>
				<div style="padding-bottom: 10px;">
					<el-button size="mini" class="bottom_all" style="margin-left: 0;" @click="addItemData()">
						<i class="icon iconfont iconicon_button_add" style="font-size: 12px;"></i>
						添加
					</el-button>
					<div style="float:right;">
						<el-select v-model="priorityNo" placeholder="请选择">
							<el-option v-for="item in conditions" :key="item" :label="`优先级${item}`" :value="item+1"></el-option>
						</el-select>
					</div>
				</div>
				<div style="padding-top:20px;">
					<el-form label-position="left" label-width="120px">
						<el-form-item>
							<span slot="label" style="color: #ff0000">优先级名称</span>
							<el-input v-model="priorityName" style="width:50%;" placeholder="请输入优先级名称"></el-input>
						</el-form-item>
					</el-form>
				</div>
				<el-table :data="dialogTable" style="width: 100%">
					<el-table-column align="center" label="条件">
						<template slot-scope="scope">
							<el-select v-model="scope.row.conditionKeyCode" placeholder="请选择" @change="scope.row.conditionValue='',scope.row.arr=[], changeCondition(scope.row.conditionKeyCode, scope.$index)">
								<el-option v-for="item in newtableData" :key="item.code" :label="item.name" :value="item.code"></el-option>
							</el-select>
						</template>
					</el-table-column>
					<el-table-column align="center" label="类型">
						<template slot-scope="scope">
							<el-select v-model="scope.row.conditionTypeCode" placeholder="请选择">
								<el-option label="等于" value="0"></el-option>
								<el-option label="不等于" value="1"></el-option>
								<el-option label="大于" value="2"></el-option>
								<el-option label="大于等于" value="3"></el-option>
								<el-option label="小于" value="4"></el-option>
								<el-option label="小于等于" value="5"></el-option>
								<el-option label="in" value="6"></el-option>
							</el-select>
						</template>
					</el-table-column>
					<el-table-column align="center" label="条件值类型">
						<template slot-scope="scope">
							<el-select v-model="scope.row.conditionValueType" placeholder="请选择">
								<el-option label="字符串" value="string"></el-option>
								<el-option label="整数" value="int"></el-option>
								<el-option label="数值" value="double"></el-option>
							</el-select>
						</template>
					</el-table-column>
					<el-table-column align="center" label="条件值">
						<template slot-scope="scope">
							<el-select v-if="scope.row.type===8" v-model="scope.row.arr" placeholder="请选择岗位" filterable multiple @change="change1(scope.row)">
								<el-option v-for="item in jobList" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
							<el-select v-else-if="scope.row.conditionKeyCode=='submiterRole' || scope.row.type === 5" v-model="scope.row.arr" placeholder="请选择角色" filterable multiple @change="change1(scope.row, 'submiterRole')">
								<el-option v-for="item in rolelist" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
							<el-cascader v-else-if="scope.row.conditionKeyCode=='submiterOrganization' || scope.row.type === 4" v-model="scope.row.arr" :show-all-levels="false" :options="organizationlist" :props="props" filterable @change="change1(scope.row)"></el-cascader>
							<el-select v-else-if="scope.row.type==2" v-model="scope.row.arr" placeholder="请选择" filterable multiple @change="change1(scope.row)">
								<el-option v-for="item in scope.row.arryList" :key="item.id" :label="item.itemName" :value="item.itemValue"></el-option>
							</el-select>
							<div v-else-if="scope.row.type === 11">
								<span v-for="(item, index) in scope.row.arr" :key="item.id">{{item.name}} <i class="el-icon-error" style="color: red; cursor: pointer; padding-left: 5px;" @click="removePerson(scope.$index, index)"></i></span>
							</div>
							<el-input v-else v-model="scope.row.conditionValue"></el-input>
						</template>
					</el-table-column>
					<el-table-column align="center" width="170">
						<template slot-scope="scope">
							<div v-if="scope.row.type === 11">
								<el-button class="bottom_all" style="margin: 0;float:left;" size="mini" @click="showPersonDialog(scope.$index)">选择</el-button>
								<el-button size="mini" style="float:right;" class="bottom_two" @click="deleteTable(scope.$index)">
									<i class="icon iconfont iconicon_button_delete" style="font-size: 12px;"></i>
									删除
								</el-button>
							</div>
							<el-button v-else size="mini" class="bottom_two" @click="deleteTable(scope.$index)">
								<i class="icon iconfont iconicon_button_delete" style="font-size: 12px;"></i>
								删除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button class="bottom_all_two" size="medium" @click="handleClose">取 消</el-button>
			<el-button class="bottom_all" size="medium" @click="sureSubmit">确 定</el-button>
		</span>

		<personModel :visible='visible' :type="1" @closeModel='closeModel' @getPerson='setSendPerson' />
	</el-dialog>
</template>

<script>
import { queryPage as queryrolePage } from '@/api/basedata/role.js';
import { formatTreeData } from '@/utils/utils'
import { queryPage as queryorganPage } from '@/api/basedata/organization.js';
import { queryPage as querJobPage } from '@/api/basedata/jobs.js';
import personModel from '@/components/ChoisePerson/personModel';
import { getDicType } from '@/api/common';
export default {
	props: ["conditionVisible", "tableData", 'conditionTable', 'conditions', 'conditionData'],
	components: {
		personModel,
	},
	data() {
		return {
			dialogTable: [],
			priorityNo: '',
			newtableData: [], 
			rolelist: [],
			jobList: [],
			organizationlist: [],
			priorityName:"",
			props: {
				children: 'children',
				label: 'name',
				multiple: true,
				checkStrictly: true,
				value: 'id',
			},
			visible: false,
			currentIndex: ''
		};
	},
	watch: {
		conditionVisible(newVal) {
			if (newVal) {
				this.dialogTable = this.conditionTable || [];
				this.priorityNo = this.conditionData.priorityNo+1;
			}
		},
	},
	methods: {
		onOpen() {
			let objArr = [{ name: "发起人角色", id: 1, code: 'submiterRole', arr: [] }, { name: "发起人组织", id: 2, code: 'submiterOrganization', arr: [] }]
			// 邱老师要求去掉发起人角色、发起人组织，by rogerwei 220421
			// let objArr = []
			this.newtableData = [...objArr, ...this.tableData]
			const params = {
				page: 1,
				pageSize: 99999,
			}
			this.priorityName = this.conditionData.processApprovalNodeVo?this.conditionData.processApprovalNodeVo.approvalName:"";
			// console.log(this.newtableData)
			queryrolePage({
				...params,
				roleEentrance: 'entrance_manager',
				enable: 1
			}).then(res => {
				this.rolelist = JSON.parse(JSON.stringify(res.data.data))
			})
			queryorganPage({
				...params,
				showEnable: 0,
				statusAttribute:1,
			}).then(res => {
				if (res.code === 1001) {
					const {
						data
					} = res.data;
					this.organizationlist = formatTreeData(data, 'id', 'parentId', 'children', 'parent_id');
				}
			})
			querJobPage({...params}).then(res => {
				this.jobList = JSON.parse(JSON.stringify(res.data.data))
			})
		},
		changeCondition (value, index) {
			/**
			 * @Description: 判断是否是数据字典
			 * @param {*}
			 * @Author: wangwangwang
			 */	
			console.log(value, index)
			const choiseConditions = this.newtableData.find(item => item.code === value);
			console.log(choiseConditions.dataSource)
			if (choiseConditions.dataSource === 1) {
				const params = {
					code: choiseConditions.dataSourceValues,
				}
				getDicType(params).then(res => {
					if (res.code === 1001) {
						this.dialogTable[index].arryList = res.data.items;
						this.dialogTable[index].type = 2;
					}
				})
			}
			this.dialogTable[index].type = choiseConditions.dataSource
		},
		addItemData() {
			const data = {
				conditionKeyCode: '',
				conditionTypeCode: '',
				conditionValue: '',
				conditionValueType: 'string',
				arr: [],
				arryList: [],
				type: '',
			};
			this.dialogTable.push(data);
		},
		deleteTable(index) {
			this.dialogTable.splice(index, 1);
		},
		handleClose() {
			this.$emit('closeVisible');
		},
		change1(low, type) {
			var str = '';
			low.arr.forEach(item => {
				if(type) {
					str = str ? str + ',' + item : item;
				}else {
					if(item.length > 1) {
						str = str ? str + ',' + item[item.length-1] : item[item.length-1];
					}else {
						str = str ? str + ',' + item[0] : item[0];
					}
				}
			})
			low.conditionValue = str;
			this.$forceUpdate();
		},
		sureSubmit() {
			if (!this.dialogTable.length) {
				this.$message.warning('条件不能为空');
				return
			}
			if (this.priorityName=="") {
				this.$message.warning('优先级名称不能为空');
				return
			}
			this.$emit('sendCondition', this.dialogTable, this.priorityNo-1, this.priorityName);
		},
		closeModel() {
			this.visible = false;
		},
		setSendPerson(data) {
			this.dialogTable[this.currentIndex].arr = data
			this.visible = false;
		},
		showPersonDialog(index) {
			this.currentIndex = index
			this.visible = true;
		},
		removePerson(tableIndex, index) {
			this.dialogTable[tableIndex].splice(index, 1)
		}
	},
	mounted() {
		if (this.conditionTable) {
			this.dialogTable = this.conditionTable;
		} else {
			this.dialogTable = [];
		}
		this.priorityName = '';
	}
};
</script>
<style lang="scss" src="./../newflows.scss" scoped></style>
<style scoped>
.dialoginfo {
  padding: 0;
  border: 1px #e1e5ed solid;
}
</style>
